<h2 mat-dialog-title>Edit Billing: {{ data.contractLabel }}</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="billing-form">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Fee</mat-label>
      <input matInput type="number" formControlName="fee" placeholder="0">
      <mat-icon matPrefix>percent</mat-icon>
      <mat-error>{{ getErrorMessage('fee') }}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Payment Status</mat-label>
      <mat-select formControlName="payment_status">
        <mat-option value="Payed">Payed</mat-option>
        <mat-option value="NotPayed">NotPayed</mat-option>
      </mat-select>
      <mat-error>{{ getErrorMessage('payment_status') }}</mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="form.invalid">
    Save
  </button>
</mat-dialog-actions>
